export const ALPHA_TESTING_CONFIG = {
  WELCOME_MESSAGE_POSITION: "top" as const,
  MANDATORY_FEEDBACK: true,
  FEEDBACK_CSS_CLASS: "pathfinder-feedback-icon",
  FEEDBACK_URL: "https://app.smartsheet.com/b/form/0e23e46defbb4778b8f0e3e29db4b343",
} as const;

export const STANDARD_CONFIG = {
  WELCOME_MESSAGE_POSITION: "center" as const,
  MANDATORY_FEEDBACK: false,
} as const;

export const GUIDANCE_MESSAGES = {
  STANDARD: "PathFinder Chatbot is in Beta; accuracy of results may vary. Sources are referenced in the response. Please provide feedback to help improve the tool.",
  ALPHA: "I can find answers to your questions based on the information available on Pathfinder.",
} as const;

export const FEEDBACK_COLORS = {
  positive: {
    default: "#16A34A",
    hover: "#15803D",
    activeBackground: "#DCFCE7",
    hoverBackground: "#F0FDF4",
  },
  negative: {
    default: "#DC2626",
    hover: "#B91C1C",
    activeBackground: "#FEE2E2",
    hoverBackground: "#FEF2F2",
  },
} as const;
